<!-- This component will be loaded in layout.blade.php every login page for Admin at the moment -->
<!-- within template, you can access props like how we access data  -->
<template>
    <li class="dropdown notifications-menu">
        <a href="#" class="dropdown-toggle" data-toggle="dropdown" @click="notificationIcon">
            <i class="fa fa-bell-o"></i>
            <span class="label label-warning" id="new_notification_count">{{ newNotifications_count }}</span>
        </a>
        <ul class="dropdown-menu" id="dropdown-menu">
            <li class="header">You have <span id="new_notification_count2">{{ newNotifications_count }}</span> notification<span id="new_notification_count_s">{{ (newNotifications_count > 0) ? 's' : '' }}</span></li>
            <li>
                <!-- inner menu: contains the actual data -->
                <ul class="menu">
                    <li v-for="newnotification in newNotifications_list">
                        <!-- start message -->
                        <a :href="newnotification.url" v-bind:id="'notifications_'+ moment(newnotification.created_at).format('YYMM') + ':' + newnotification.id" @click="notificationView">
                            <h4 style="margin: 0;">
                                <small class="pull-left" style="color:black">
                                    <span>{{ newnotification.status_message }}</span>
                                </small>
                                <small class="pull-right">
                                    <i class="fa fa-clock-o"></i>
                                    <template
                                        v-if="currentDateTime.diff(newnotification.updated_at, 'minutes') < 60">{{ currentDateTime.diff(newnotification.updated_at, 'minutes') }}
                                        min{{ currentDateTime.diff(newnotification.updated_at, 'minutes') > 1 ? 's' : '' }}
                                    </template>
                                    <template
                                        v-else-if="(currentDateTime.diff(newnotification.updated_at, 'hours') < 10)">{{ currentDateTime.diff(newnotification.updated_at, 'hours') }}
                                        hour{{ currentDateTime.diff(newnotification.updated_at, 'hours') > 1 ? 's' : '' }}
                                    </template>
                                    <template
                                        v-else-if="(currentDateTime.diff(newnotification.updated_at, 'hours') <= 24)">Today
                                    </template>
                                    <template
                                        v-else-if="(currentDateTime.diff(newnotification.updated_at, 'hours') > 24) && (currentDateTime.diff(newnotification.updated_at, 'hours') < 48)">Yesterday
                                    </template>
                                    <template
                                        v-else-if="(currentDateTime.diff(newnotification.updated_at, 'hours') >= 48) && (currentDateTime.diff(newnotification.updated_at, 'days') < 8)">{{ currentDateTime.diff(newnotification.updated_at, 'days') }}
                                        day{{ currentDateTime.diff(newnotification.updated_at, 'days') > 1 ? 's' : '' }}
                                    </template>
                                    <template
                                        v-else-if="(currentDateTime.diff(newnotification.updated_at, 'days') >= 8)">{{ moment(newnotification.updated_at) . format('Do MMM') }}
                                    </template>
                                </small>
                                <br />
                                <template v-if="newnotification.unread == 1">
                                    <span class="dot pull-right"></span>
                                </template>
                            </h4>
                            <template v-if="newnotification.status == 0 && newnotification.title.includes('Import Contact')">
                                <p class="wrap-text">Status: {{ newnotification.content }}</p>
                            </template>
                            <template v-else-if="newnotification.title != ''">
                                <p class="overflow">Title: {{ newnotification.title }}</p>
                            </template>
                            <template v-else-if="newnotification.title == ''">
                                <p class="overflow">Content: {{ newnotification.content }}</p>
                            </template>
                        </a>
                    </li><!-- end message -->
                </ul>
            </li>
            <li class="footer"><a :href="event_url">See All Events</a></li>
        </ul>
    </li>
</template>

<script>
    import moment from 'moment'
    var axios = require('axios');

    export default {
		data() {
			// these data we can't set under resources/js/app.js as we need runtime data
			// new_msgs_data['whatsapp_icon_src'] = this.baseroute + '/images/whatsapp-icon.svg';
            /* These data previous set inside app.js */
            var new_notifications_data = {
				newNotifications_list		: [],     // define empty variable
                newNotifications_count		: 0,
                currentDateTime 	        : null,
                moment          	        : moment,
			};
			new_notifications_data['event_url'] = this.baseroute + '/events';
			return new_notifications_data;		// load data from resources/js/app.js, this way, we can share the data across the html
		},
		created() {     // Run this after vue object created
			this.fetchNewNotificationsList();
		},
		props: [		// Data pass in from layout.blade.php
			'user_id',
			'company_id',
        	'baseroute',
        	'testProps',
		],
		methods: {
            notificationIcon() {
                console.log('onclick notification icon');
                this.newNotifications_count = "";
                axios.post(this.baseroute + '/postNotificationID', {
                    totalUnread: ""
                });
            },
            notificationView:function(e){
                console.log('View notification, id = '+ e.currentTarget.id);
                axios.post(this.baseroute + '/postNotificationID', {
                    readNotificationID: e.currentTarget.id
                });
            },
			fetchNewNotificationsList() {     // Define the fetchNewNotificationsList() function
				console.log("fetchNewNotificationsList(), this.baseroute = " + this.baseroute + '/getNewNotificationsList');
				this.currentDateTime = moment();
				axios.get(this.baseroute + '/getNewNotificationsList')
                .then(response => {
                    console.log('response:', response);
                    this.newNotifications_count = response.data.newNotificationCount;
                    this.newNotifications_list = response.data.new_notifications_list;

                    console.log("newNotifications_count = " + this.newNotifications_count);
                    console.log("newNotifications_list = ");
                    console.log(this.newNotifications_list);
                })
                .catch(function (error) {
                    // Wu oh! Something went wrong
                    console.log("Failed fecthing new msg");
                    console.log(error.message);
                });
			},
		},
		mounted() {     // Run this after vue object mounted on html screen
		  	console.log('NewNotificationsList.vue Component mounted.')
		},
		computed: {

		}
    }
</script>

<style scoped>
.dot {
    height: 13px;
    width: 13px;
    background-color: rgb(18, 155, 5);
    border-radius: 50%;
    display: inline-block;
}

.overflow {
    color: #777777;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
}

#dropdown-menu {
    width: 500px !important;
}

/* Media query for mobile devices with a maximum width of 768px (adjust this value if needed) */
@media (max-width: 768px) {
    #dropdown-menu {
        width: 100% !important; /* Set the width to 100% to occupy the full width of the screen on mobile devices */
        max-width: 500px !important; /* Set a maximum width to prevent the menu from becoming too wide on large screens */
    }
}
</style>
